<div class="d-md-flex justify-content-between align-items-center">
  <h4 *ngIf="largetitle !== 'true'">{{title}}</h4>
  <h1 *ngIf="largetitle === 'true'">{{title}}</h1>
  <link-icon *ngIf="to" class="" icon="thin-arrow-right" [to]="to">{{ linktitle || 'Overview'}}</link-icon>
</div>
<ng-content></ng-content>
